export { FooterDesktop } from "./FooterDesktop";
